import React,{useMemo} from "react";
import { useTable } from 'react-table';
import axios from "axios";

//변수명 추가/변경
const FlySearchResult = ({varColumnLists,varFlyLists,GetFlyList,onEditFlyHandler}) => {

  //컬럼 - 제목부
  const columns = useMemo(() => {
    if(varColumnLists?.length > 0) return varColumnLists; 
    // eslint-disable-next-line
  },[varColumnLists]);

  //표시할 정보
  const data = useMemo(() => {
    if(varFlyLists?.length > 0) return varFlyLists;
    // eslint-disable-next-line
  }, [varFlyLists]);

  //테이블 정보 설정 - 체크박스 포함
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} 
      = useTable({ columns, data, initialState:{hiddenColumns:["vt_idx","vt_status","vt_mode"]}});

  //변수명 사용유무
  const onToggleFlyHandler = async(e,vt_idx,vt_status) => {
    let sprompt = '선택된 변수명을 삭제합니까?';
    if(vt_status === 1) sprompt = '선택된 변수명을 사용합니까?';
    if (!window.confirm(sprompt)) return false;

    const sendData = {vt_idx:vt_idx,vt_status:vt_status};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_toggle_fly_status`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        GetFlyList();
      } else {
        alert(res.data.message);
      }
    });    
  }
  
  return (
    <div className="scroll-table">
      <table className="list scroll delivery" {...getTableProps()}>
        {varColumnLists?.length===0?<thead></thead>:
          <thead>
            {headerGroups.map((headerGroup) => {
              const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
              return (
                <tr key={key} {...restHeaderGroupProps}>
                  {headerGroup.headers.map(column => {
                    const { key, ...restColumn } = column.getHeaderProps({style:{width:column.width}});
                    return (
                      <th key={key} {...restColumn}>{column.render('Header')}</th>
                    );
                  })}
                  <th style={{width:"150px"}}>상세</th>
                </tr>
              )
            })}
          </thead>
        }
        {varFlyLists?.length===0?
          <tbody><tr><td colSpan={5}>등록된 변수명이 없습니다.</td></tr></tbody>
          :
          <tbody {...getTableBodyProps()}>
            {rows.map((row,i) => {
              prepareRow(row);
              const { key, ...restRowGroupProps } = row.getRowProps();
              return (
                <tr key={key} {...restRowGroupProps}>
                  {row.cells.map((cell,i) => {
                    const { key, ...restCellProps } = cell.getCellProps();
                    return (
                      <td key={key} {...restCellProps}>{cell.render('Cell')}</td>
                    );
                  })}
                  <td>
                    <button className="btn line black" onClick={e=>onEditFlyHandler(e,row.values.vt_idx)}>상세</button>
                    {row.values.vt_status===1?
                      <button onClick={e=>onToggleFlyHandler(e,row.values.vt_idx,0)} style={{width:"70px"}} className="btn line black">삭제</button>
                    :
                      <button onClick={e=>onToggleFlyHandler(e,row.values.vt_idx,1)} style={{width:"70px"}} className="btn line black">사용</button>
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        }
      </table>
    </div>
  )
}
export default FlySearchResult;